import React from 'react';
import { Collapse, Table, Empty, Row, Col, Button } from 'antd';
import { StrippingScheduleHandler } from '../StrippingScheduleHandler';
import { StrippingScheduleModel } from '../Models/StrippingScheduleModel';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import Utility from 'Core/Utility';
import { tsObjectKeyword } from '@babel/types';
import { ArrowsAltOutline } from '@ant-design/icons';

export interface Props {
  children?: React.ReactNode;
  schedule?: any;
  searchDate?: any;
  searchContainer?: any;
  isHomeMode?: boolean;
}

export interface State { expandAll: string }

export default class StrippingScheduleDataTable extends React.Component<Props, State> {
  private columns = [
    { title: 'Container #', dataIndex: 'containerNumber', key: 'containerNumber' },
    {
      title: 'Date',
      dataIndex: 'scheduledDateAndTime',
      key: 'scheduledDateAndTime',
      render: this.renderDateInTable,
    },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    { title: 'Category', dataIndex: 'category', key: 'category' },
  ];

  private strippingScheduleHandler: StrippingScheduleHandler;

  constructor(props: Props) {
    super(props);
    this.strippingScheduleHandler = new StrippingScheduleHandler(props);
    this.state = { expandAll: "normal" };
  }

  renderDateInTable(text, record, index) {
    return Utility.ToDateString(moment(text));
  }

  displaySchedule(schedule) {
    const pageSize = this.props.isHomeMode ? 1 : 5;
    const { Panel } = Collapse;
    const rows: JSX.Element[] = [];
    //group data by location
    var grouped = (schedule || []).reduce((accumulator, obj) => {
      const key: string = obj['stripLocation'] as string;
      if (!accumulator[key]) {
        accumulator[key] = [];
      }
      //format schedule date
      obj.scheduledDateAndTime = Utility.ToDateTimeString(moment(obj.scheduledDateAndTime));
      accumulator[key].push(obj);
      return accumulator;
    }, {});

    //add each grouped data to a table
    Object.keys(grouped).map((i: any) => {
      const data = grouped[i];

      if (this.state.expandAll == "expand") {
        rows.push(
          <div onClick={() => this.setState({ expandAll: "normal" })}>
            <Collapse activeKey={i}>
              <Panel header={i} key={i}>
                <Table pagination={{ pageSize: pageSize }} dataSource={data} columns={this.columns} />
              </Panel>
            </Collapse>
          </div>
        );
      }
      else if (this.state.expandAll == "collapse") {
        rows.push(
          <div onClick={() => this.setState({ expandAll: "normal" })}>
            <Collapse activeKey={0} >
              <Panel header={i} key={i}>
                <Table pagination={{ pageSize: pageSize }} dataSource={data} columns={this.columns} />
              </Panel>
            </Collapse>
          </div>

        );
      }
      else {
        rows.push(
          <Collapse >
            <Panel header={i} key={i} forceRender={true}>
              <Table pagination={{ pageSize: pageSize }} dataSource={data} columns={this.columns} />
            </Panel>
          </Collapse>
        );
      }
      return rows;
    });

    return rows;
  }

  render() {
    return (
      // {this.props.isHomeMode ? this.displaySchedule(this.state.schedule) : this.displaySchedule(this.props.schedule)}
      <div>
        {this.props.isHomeMode === true ? (
          <Row>
            <Col style={{ textAlign: 'center' }}>
              {' '}
              <p style={{ float: 'left', display: 'inline-block' }}>
                Showing results for: {this.props.searchDate}
              </p>
              <NavLink to="/container-schedule">More Details</NavLink>
            </Col>{' '}
          </Row>
        ) : (
            <Row>
              <Col>
                <p style={{ float: 'left', display: 'inline-block' }}>
                  Showing results: {this.props.searchDate || 'All Dates'}{' '}
                </p>
                <p style={{ textAlign: 'right' }}>{this.props.searchContainer || 'All Locations'}</p>
              </Col>
              <Col span={2}>
                <Button type="primary" size={"small"} onClick={() => this.setState({ expandAll: this.state.expandAll == "expand" ? "collapse" : "expand" })}>
                  {this.state.expandAll == "expand" ? "Close All" : "Show All"}
                </Button>
              </Col>
            </Row>
          )}
        <Row>
          <Col>
            {this.props.schedule && this.props.schedule.length > 0 ? (
              this.displaySchedule(this.props.schedule)
            ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
          </Col>
        </Row>
      </div>
    );
  }
}
